var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurnkeySolutions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 63.375V19.5C84.5 16.8188 82.3063 14.625 79.625 14.625H58.5C58.5 11.9438 56.3063 9.75 53.625 9.75H50.375C47.6938 9.75 45.5 11.9438 45.5 14.625H24.375C21.6938 14.625 19.5 16.8188 19.5 19.5V63.375C17.7125 63.375 16.25 64.8375 16.25 66.625V69.875C16.25 71.6625 17.7125 73.125 19.5 73.125H39.6175L29.4288 93.5187L30.875 94.25H32.695L36.7575 86.125H63.9925L68.055 94.25H69.875L71.3213 93.5187L61.1325 73.125H84.5C86.2875 73.125 87.75 71.6625 87.75 69.875V66.625C87.75 64.8375 86.2875 63.375 84.5 63.375ZM48.75 14.625C48.75 13.7313 49.4813 13 50.375 13H53.625C54.5187 13 55.25 13.7313 55.25 14.625V17.875C55.25 18.7688 54.5187 19.5 53.625 19.5H50.375C49.4813 19.5 48.75 18.7688 48.75 17.875V14.625ZM22.75 19.5C22.75 18.6062 23.4812 17.875 24.375 17.875H45.5C45.5 20.5562 47.6938 22.75 50.375 22.75H53.625C56.3063 22.75 58.5 20.5562 58.5 17.875H79.625C80.5188 17.875 81.25 18.6062 81.25 19.5V63.375H60.125V60.19C60.125 58.37 58.63 56.875 56.81 56.875H43.94C42.12 56.875 40.625 58.37 40.625 60.19V63.375H22.75V19.5ZM43.94 60.125L56.875 60.19V63.375H43.8913L43.94 60.125ZM62.3675 82.875H38.3825L40.0075 79.625H60.7425L62.3675 82.875ZM41.6325 76.375L43.2575 73.125H57.4925L59.1175 76.375H41.6325ZM84.5 69.875H19.5V66.625H84.5V69.875Z",
    fill: "#FBF9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 32.5H26V35.75H45.5V32.5Z",
    fill: "#FBF9EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 39H26V42.25H45.5V39Z",
    fill: "#FBF9EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 45.5H26V48.75H39V45.5Z",
    fill: "#FBF9EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 42.25H55.25V48.75H58.5V42.25Z",
    fill: "#FBF9EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35.75H61.75V48.75H65V35.75Z",
    fill: "#FBF9EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 32.5H68.25V48.75H71.5V32.5Z",
    fill: "#FBF9EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39H74.75V48.75H78V39Z",
    fill: "#FBF9EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.875 60.125H43.875V63.375H56.875V60.125Z",
    fill: "#FBF9EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.25 17.875C55.25 18.772 54.522 19.5 53.625 19.5H50.375C49.478 19.5 48.75 18.772 48.75 17.875V14.625C48.75 13.728 49.478 13 50.375 13H53.625C54.522 13 55.25 13.728 55.25 14.625V17.875Z",
    fill: "#FBF9EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnkeySolutions);
export default __webpack_public_path__ + "static/media/turnkey-solutions.240aff66776e1008df0d2bf8aeb86a9e.svg";
export { ForwardRef as ReactComponent };